const SET_USER = "SET_USER";
const SET_BATONS = "SET_BATONS";

export { SET_USER, SET_BATONS };
